import { z } from "zod";

import { UUID } from "../generic/uuid.ts";

// ================================================
// SELECT
// ================================================

// Target
export const Target = z
  .strictObject({
    id: UUID,
    message_id: UUID,
    target_id: UUID,
    created_at: z.string(),
    updated_at: z.string(),
  })
  .refine((data) => data.created_at <= data.updated_at, {
    message: '"created_at" must be before or equal to "updated_at"',
  });
export type Target = z.infer<typeof Target>;

// ================================================
// INSERT
// ================================================

// TargetInsert
export const TargetInsert = Target.omit({
  id: true,
  created_at: true,
  updated_at: true,
});
export type TargetInsert = z.infer<typeof TargetInsert>;
